var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"open-guided-tour-btn",on:{"click":_vm.openGuidedTour}},[_c('i',{staticClass:"far fa-lightbulb"})])}
var staticRenderFns = []

export { render, staticRenderFns }